import { atomFamily, atomWithDefault } from "jotai/utils";
import { atom } from "jotai";
import { type BuildLogs } from "./utils/types";
import {
  type AppetizeClient,
  type AppetizeSessionHandle,
} from "./utils/appetize";
import { Store } from "@tanstack/store";

const buildLogsAtomWithId = atomFamily((id?: string) => {
  return atomWithDefault((get) => {
    const buildLogs: BuildLogs = {
      logs: [],
      networkLogs: [],
      interactionLogs: [],
      videoFrames: [],
      audioFrames: [],
      getUIElements: [],
    };
    return buildLogs;
  });
});

const appetizeClientAtom = atom<AppetizeClient | null>(null);

const appetizeSessionStore = new Store<AppetizeSessionHandle>({
  getData: () => null,
  startedAt: null,
});

export { buildLogsAtomWithId, appetizeClientAtom, appetizeSessionStore };
